@import '../../../../constants/spacing.module.less';

.activity-pill {
  background-color: var(--gray-F1F2F3);
  border-radius: 16px;
  padding: @space-4 @space-8;
  white-space: nowrap;
  font-weight: 500;
}
